import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'

import Header from 'views/Global/Header'
import Footer from 'views/Global/Footer'

import WhoWeAre from 'views/WhoWeAre'
import Locations from 'views/Locations'
import renderLocationDetail from 'views/LocationDetail'
import Departments from 'views/Departments'
import renderDepartmentDetail from 'views/DepartmentDetail'
import Openings from 'views/Openings'
import NotFound from 'views/NotFound'

class Routes extends React.Component {
  static propTypes = {
    location: PropTypes.object,
  }

  state = {
    isScrollDisabled: false,
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.isScrollDisabled) {
      document.body.classList.add('h-100')
      document.body.classList.add('w-100')
      document.body.classList.add('overflow-hidden')
    } else {
      document.body.classList.remove('h-100')
      document.body.classList.remove('w-100')
      document.body.classList.remove('overflow-hidden')
    }

    if (prevProps.location.pathname !== this.props.location.pathname) {
      window.scroll(0, 0)
    }
  }

  onClickHamburger = value => {
    this.setState({
      isScrollDisabled: value,
    })
  }

  isOpaqueRoute = () => {
    return [
      '/404',
    ].includes(this.props.location.pathname)
  }

  render () {
    return [
      <Header key='header' isOpaque={this.isOpaqueRoute()} onClickHamburger={this.onClickHamburger} />,
      <main key='main' className='flex-auto'>
        <Switch>
          <Route path='/' exact component={WhoWeAre} />
          <Route path='/locations' exact component={Locations} />
          <Route path='/locations/:locationId'
            exact
            render={renderLocationDetail}
          />
          <Route path='/openings' exact component={Openings} />
          <Route path='/departments' exact component={Departments} />
          <Route path='/departments/:departmentId'
            exact
            render={renderDepartmentDetail}
          />
          <Route path='/404' exact component={NotFound} />
          <Route render={() => (<Redirect to='/404' />)} />
        </Switch>
      </main>,
      <Footer key='footer' />,
    ]
  }
}

export default withRouter(Routes)
